export const cleanReviewsDate = (date?: string) => {
  if (date && date.includes('/')) {
    return date.split('/').reverse().join('-');
  }

  return date;
};
